'use client'

// import { CreatorList } from '@/components/creator-list'
// import { ChannelType } from '@/constants/channel'
// import { VideosRanking } from '@/components/videos-ranking'
// import { SectionCard } from '@/components/section-card'
// import { ChannelType } from '@/constants/channel'
// import { VideosRanking } from '@/components/videos-ranking'
// import { SectionCard } from '@/components/section-card'
import BottomNav from '@/components/bottom-nav'
import Footer from '@/components/footer'
import Navbar from '@/components/nav-bar'
import { SideNav } from '@/components/side-nav'
import React from 'react'
import { AiOutlineArrowUp } from 'react-icons/ai'

export default function layout({ children }) {
  const handleScrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  return (
    <>
      <div className='mb-20 lg:mb-5'>
        <Navbar />
      </div>
      <div className='mx-auto max-w-[1920px] flex-1 gap-x-5 md:justify-center lg:grid lg:grid-cols-[220px_minmax(auto,1fr)] lg:px-5'>
        <aside>
          <SideNav />
        </aside>
        <main className='flex w-full flex-1 flex-col overflow-hidden'>
          {children}
        </main>
        {/* <div className='flex flex-col gap-y-5'>
          <SectionCard title='熱門創作者'>
            <CreatorList amount={5} />
          </SectionCard>
          <SectionCard title='排行榜'>
            <VideosRanking type={ChannelType.Popular} amount={5} />
          </SectionCard>
        </div> */}
      </div>
      <div className='px-6 py-8 md:pt-0 lg:px-[135px]'>
        <button
          onClick={handleScrollTop}
          className='ml-auto flex h-10 w-10 items-center justify-center rounded-lg bg-[#FF3C8E]'
        >
          <AiOutlineArrowUp className='text-xl' />
          {/* <IconArrowUp /> */}
        </button>
      </div>
      <div className='lg:mt-5'>
        <Footer />
      </div>
      <div className='mt-20 lg:hidden'>
        <BottomNav />
      </div>
    </>
  )
}
